﻿import { IGOMAveragesSet } from "../../API/GOMAverages/GOMAveragesSet";
import { LiveDataSet } from "../../API/LiveData/LiveDataSet";
import { ParameterSchemaStation } from "../../API/Schema/ParameterSchema";
import { IStationValueObject } from "../../Formatters/IStationValueFormatter";
import { IGOMAveragesListener } from "../../IGOMAveragesListener";
import { IHashData } from "../../IHashData";
import { ILiveDataListenerContext, ILiveDataListener } from "../../ILiveDataListener";
import { IPage } from "../../IPage";
import { MainSite } from "../../MainSite";
import { Station } from "../../Model/Station";
import { GOMCurrentPage } from "../GOMCurrent/GOMCurrentPage";
import { Clouds } from "./Clouds";
import { Current } from "./Current";
import { GomDashboard } from "./GomDashboard";
import { ISiteObservationsPage } from "./ISiteObservationsPage";
import { Motion } from "./Motion";
import { Overview } from "./Overview";
import { Penguins_Lifeboat } from "./Penguins_Lifeboat";
import { RIGS } from "./RIGS";
import { RIGS_Heading } from "./RIGS_Heading";
import { Risers } from "./Risers";
import { RtcpDashboard } from "./RtcpDashboard";
import { Waves } from "./Waves";
import { Wind } from "./Wind";
import { WindProfile } from "./WindProfile";

export class SiteObservations implements IPage, ILiveDataListenerContext {
    public static getLandingPageId(station: Station): string {
        if (station.Region == 'GOM') {
            return "gomdashboard";
        }

        return "overview";
    }

    constructor(private mainSite: MainSite) {
        this.timestampContainer = $('<span></span>').text("Waiting for data...");

        // console.log('this.stationSchema.Station.Id: ', this.stationSchema.Station.Id)
        // console.log('mainSite.staticDataManager.Schema.ParameterSchema.Stations: ', mainSite.staticDataManager.Schema.ParameterSchema.Stations)
        console.log('mainSite: ', mainSite)
        // console.log('mainSite.staticDataManager: ', mainSite.staticDataManager.Schema)
        console.log()

        //const [dataContext, setDataContext] = React.useState<any>({
        //    "station": this.station,
        //    "warningGroup": this.warningGroup,
        //    "mainSite": this.mainSite
        //})

        this.pages = [
            new Overview(mainSite, this),
            new GomDashboard(mainSite, this),
            new Clouds(mainSite, this),
            new Waves(mainSite, this, null, null),
            new Current(mainSite, this, null, null),
            //new GOMCurrent(mainSite, this, null, null),
            new GOMCurrentPage(mainSite, this, null, null),
            new Motion(mainSite, this),
            new Wind(mainSite, this, false),
            new Wind(mainSite, this, true),
            new WindProfile(mainSite, this),
            new RtcpDashboard(mainSite, this),
            new Risers(mainSite, this),
            new RIGS(mainSite, this),
            new RIGS_Heading(mainSite, this),
            new Penguins_Lifeboat(mainSite, this)
        ];
    }

    private pages: ISiteObservationsPage[];

    private page: ISiteObservationsPage; // the current page to display
    private pageParams: string[] = [];


    public id: string = 'siteObs';

    private container: JQuery = null;
    private timestampContainer: JQuery;
    private latestTimestamp: number = null;
    private stationSchema: ParameterSchemaStation = null;

    public initialize(): void {
        this.mainSite.liveDataManager.addListener(this);
        this.mainSite.GOMAveragesManager.addListener(this);

        $(window).resize(() => {
            this.resizeWindow();
        });
    }

    private navBar: JQuery = null;

    public liveDataChanged(latestData: LiveDataSet): void {
        this.listeners.forEach((listener: ILiveDataListener) => {
            listener.liveDataChanged(latestData, this);
        });
    }

    public GOMAveragesChanged(latestData: IGOMAveragesSet): void {
        this.GOMAverageslisteners.forEach((listener: IGOMAveragesListener) => {
            listener.GOMAveragesChanged(latestData);
        });
    }

    private listeners: ILiveDataListener[] = [];
    private GOMAverageslisteners: IGOMAveragesListener[] = [];

    private resizeWindow(): void {
        // always 64 em across and 48 down, 4:3 aspect ratio

        if (this.container) {

            var width_limited_px: number = 16 * this.container.width() / 1024;
            var height_limited_px: number = 16 * (window.innerHeight - 104) / 768; // adjustment for top bar

            $('.midi_SiteObservations_padded_page_content').css('font-size', Math.min(height_limited_px, width_limited_px) + 'px');

            if (this.page) {
                this.page.notifyResize();
            }
        }
    }

    public handleHashChange(hashData: IHashData): boolean {
        this.latestTimestamp = null;

        if (this.navBar) {
            this.container.remove();
            if (this.page.containerOverride) {
                this.page.containerOverride.remove();
            }

            this.page = null;
            this.navBar = null;
        }

        //console.log("[SiteObservations] hashData.Page: ", hashData.Page)
        //console.log("[SiteObservations] hashData.Page === this.id: ", hashData.Page === this.id)

        if (hashData.Page === this.id) {
            this.container = $('<div class="container"></div>').appendTo('body');
            this.navBar = $('<ul class="midi_SiteObservations_nav nav nav-pills"></ul>');

            this.navBar.append($('<li></li>').append($('<a class="midi_SiteObservations_nav_timestamp"></a>').append(this.timestampContainer)));

            this.listeners = [];
            this.GOMAverageslisteners = [];

            this.stationSchema = this.mainSite.staticDataManager.Schema.ParameterSchema.Stations[this.mainSite.hashData.PageSpecificData.Station];

            const filteredPages: ISiteObservationsPage[] = [];
            for (const page of this.pages) {
                const showResult = page.show(this.stationSchema);
                if (Array.isArray(showResult)) {
                    // If page.show() returns an array then this will be a station-specific page set
                    filteredPages.push(...showResult);
                } else if (showResult) {
                    // Otherwise page.show() just returns a boolean which defines whether to show the page
                    filteredPages.push(page);
                }
            }

            if (filteredPages.length == 0) {
                filteredPages.push(this.pages[0]);
            }

            if (!filteredPages.some(x => x.id == hashData.PageSpecificData.Tab)) {
                // if the hash data points to no page or an invalid page, then use the first
                hashData.PageSpecificData.Tab = filteredPages[0].id;
            }

            filteredPages.forEach((page: ISiteObservationsPage) => {

                ((page: ISiteObservationsPage) => {

                    var link = $('<a href="#"></a>')
                        .text(page.label)
                        .click((e: JQueryMouseEventObject) => {
                            this.latestTimestamp = null;
                            hashData.PageSpecificData.Tab = page.id;
                            $(e.target).attr('href', this.mainSite.hashDataManager.encode(hashData));
                        });

                    if (page.id == hashData.PageSpecificData.Tab) {
                        link.addClass('selected');
                    }

                    this.navBar.append($('<li></li>').append(link));

                })(page);

                //console.log("[SiteObservations] page.id: ", page.id)
                //console.log("[SiteObservations] page.id == hashData.PageSpecificData.Tab: ", page.id == hashData.PageSpecificData.Tab)

                if (page.id == hashData.PageSpecificData.Tab) {
                    this.navBar.appendTo(this.container);

                    //console.log("[SiteObservations] typeof page.render: ", typeof page.render)

                    page.render(this.container, this.listeners, this.stationSchema, this.mainSite.selectedWarningRules, this.GOMAverageslisteners);

                    //try {
                    //    console.log("[SiteObservations] render a")
                    //    page.render(this.container, this.listeners, this.stationSchema, this.mainSite.selectedWarningRules, this.GOMAverageslisteners);
                    //} catch {
                    //    console.log("[SiteObservations] render b")
                    //    page.render(this.container, this.listeners, this.stationSchema, this.mainSite.selectedWarningRules);
                    //}


                    this.page = page;
                    this.container.focus();
                }
            }); 

            if (!this.page) { // invalid station id or page
                alert('Error loading page: Invalid Station or Tab');
                this.mainSite.changePage('map');
            }

            this.resizeWindow();
            $(window).resize();

            return true;
        } else {
            return false;
        }
    }

    public valueChanged(vo: IStationValueObject) {
        let timestamp = vo.Timestamp;
        let hasChanged = false;
        if (!this.latestTimestamp) {
            this.latestTimestamp = timestamp;
            hasChanged = true;
        }
        else if (timestamp > this.latestTimestamp) {
            this.latestTimestamp = timestamp;
            hasChanged = true;
        }

        if (hasChanged) {               
            if (this.latestTimestamp) {
                this.timestampContainer.text(this.mainSite.getDisplayTime(this.latestTimestamp, this.stationSchema.Station.TimeZone));
            }
            else {
                this.timestampContainer.text("Waiting for data...");
            }
        }
    }
}